import { useContext, useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { UserContext } from "../../providers/UserContext";
import { iProtectRoute } from "./types";

export const ProtectedRoutes = ({ children }: iProtectRoute) => {
  const { products, token } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
  }, []);

  return <>{products ? <Outlet /> : <Navigate to="/" />}</>;
};
